import { Selector } from '@ngxs/store';

import { VehicleIconState, VehicleIconStateModel } from './vehicle-icon.state';
import { VehicleIcon } from '../../core/models/vehicle-icon.model';

export class VehicleIconGetterState {

  @Selector([VehicleIconState])
  static getVehicleIcons(state: VehicleIconStateModel): VehicleIcon[] {
    return state.ids.map(id => state.entities[id]);
  }
}
